import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setEmployeetListsActions,
  SetEmployeeDeleteActions,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import Delete from "../../AppComponent/Popup/Delete";
import EmployeeCreate from "./EmployeeCreate";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";

const Employee = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [dtpageindex, setdtPageindexEMP] = useState(1);
  const [dtpagesizeEmp, setdtPagesizeEMp] = useState(10);
  const [pageSizeEMP, setPageSize] = useState(20);
  const [searchEmp, setsearchEMP] = useState("");
  const [newpagesEmp, setNewpageEMP] = useState(1);
  const [currentPageEmp, setcurrentPageemp] = useState(1);
  const [EmpDAta, setEmpdatas] = useState([]);
  const [DeleteIDEMP, SetDeleteEmpID] = useState("");
  const [DeleteEmpPOPUP, setDeletePOPUPEMp] = useState(false);
  const [EditIdEmp, setEditId] = useState("");
  const [EditPopupEmp, setsetEditEmpPOPUP] = useState(false);

  useEffect(() => {
    const payloads = {
      search: "",
      page_size: 20,
      page: currentPageEmp,
    };
    dispatch(setEmployeetListsActions(payloads));

    setEmpdatas(state.EmployeeListsdata.EmployeeLists);
  }, [currentPageEmp]);

 
  const handleNext = (next) => {
    
    setdtPageindexEMP(next + 1);
    
  };

   const GotoEnteredPage =(gotopage)=>{
    setdtPageindexEMP(gotopage)
   }

   const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindexEMP(previous);
   
    }
  };

  const pagesizeEMP = (arg) => {
    setdtPagesizeEMp(arg);
  };

  const pageindexEMP = (arg) => {
    setdtPageindexEMP(arg);
  };

  // -----Search------------------------
  function toEmpSearch(e) {
    console.log("ee", e);
    setsearchEMP(e);

    if (e.trim() != undefined && e.trim() !== "") {
      const payload = {
        search: e.trim(),
        page_size: 20,
        page: 1,
      };
      // console.log(e, "testnew")
      dispatch(setEmployeetListsActions(payload));
    }
    if (e == "" || searchEmp == "") {
      const payload = {
        search: "",
        page_size: 20,
        page: 1,
      };
      dispatch(setEmployeetListsActions(payload));
    }
  }

  const handlePageChangeEMP = (newPage) => {
    if (newPage < state.EmployeeListsdata.Total_Count) {
      setcurrentPageemp(newpagesEmp + 1);
      console.log(newpagesEmp, "newpagess");
      setNewpageEMP(newPage + 1);
      const pageEntries = {
        search: searchEmp,
        page_size: 10,
        page: newPage,
      };
      dispatch(setEmployeetListsActions(pageEntries));
      console.log("New Page:", newpagesEmp);
    }
  };

  const HandleEmpDelete = () => {
    if (DeleteIDEMP != undefined) {
      console.log(currentPageEmp, "sdsd");
      const payload = {
        DeleteID: DeleteIDEMP,
        currentPage: currentPageEmp,
      };
      dispatch(SetEmployeeDeleteActions(payload, setDeletePOPUPEMp(false)));
    }
  };

  const columnsEMp = [
    {
      Header: "Client",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>{row.row.original.client_id.client_name}</span>
          </>
        );
      },
    },
    {
      Header: "Role",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>{row.row.original.role_id.role}</span>
          </>
        );
      },
    },

    // {
    //     Header: "Shift",
    //     accessor: "",
    //     Cell: (row) => {

    //         return (
    //             <>
    //                 <span>{row.row.original.shift_id.shift_name}</span>
    //             </>
    //         )
    //     }
    // },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{ display: "flex", justifyContent: "flex-start", gap: "5px" }}
            >
              <button
                className=" btn Status"
                component="span"
                onClick={(e) => {
                  setsetEditEmpPOPUP(true);
                  setEditId(row.row.original.id);
                }}
              >
                <span className="OuterActionSpan">
                  <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>

              </button>

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  SetDeleteEmpID(row.row.original.id);
                  setDeletePOPUPEMp(true);
                }}
              >
                <span className="OuterActionSpan">
              
              <span  className="EditImages">
               <img src={DeleteImages}/>
             </span>

             <span className="ActionsList"> Delete </span>
           </span>

              </button>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div className="Header-Details">
          <div className="InnerUsers">
            <h3>Employee</h3>
          </div>

          {/* <div className='Add-User'>
                        <button
                            onClick={e => { winHandleLastPagedow.location.href = "/employeeCreate" }}
                        > Add  </button>
                    </div> */}
        </div>

        {EmpDAta != undefined ? (
          <div style={{ padding: "40px" }}>
            <ReactTable
              data={state.EmployeeListsdata.EmployeeLists}
              columns={columnsEMp}
              totalItems={state.EmployeeListsdata.Total_Count}
              currentPage={currentPageEmp}
              // onPageChange={handlePageChangeEMP}
              onChange={toEmpSearch}
              setCurrentPage={setcurrentPageemp}
              pagesize={pagesizeEMP}
              // onPrevious={handlePreviousEmp}
              // onNextpage={handleNextEmp}
              dtpagesize={pageSizeEMP}
              dtpageindex={currentPageEmp}
              pageindex={pageindexEMP}
              datacount={state.EmployeeListsdata.Total_Count}
              onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
              Oncreate={(e) => {
                window.location.href = "/employeeCreate";
              }}
            />
          </div>
        ) : null}
      </div>

      {DeleteEmpPOPUP ? (
        <Delete
          show={DeleteEmpPOPUP}
          setShow={setDeletePOPUPEMp}
          onSubmit={HandleEmpDelete}
        Content={"Do you want to delete "}

        />
      ) : null}

      {EditPopupEmp ? (
        <EmployeeCreate EditId={EditIdEmp} currentPage={currentPageEmp} />
      ) : null}
    </>
  );
};

export default Employee;
